import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
// import { useAppVersion } from '../hooks/useAppVersion';
import MobileDrawer from './MobileDrawer';
import NotificationBell from './NotificationBell';
import Logo from './Logo';
import CartIcon from './CartIcon';
import UserProfileDropdown from './UserProfileDropdown';
import { Menu } from 'lucide-react';

function Header() {
  const { user, logout } = useAuth();
  const { cartItems } = useCart();
  // const { latestVersion, downloadApp } = useAppVersion();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const cartCount = useMemo(() => (cartItems?.length ?? 0), [cartItems]);

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Left: Hamburger (mobile) + Logo */}
          <div className="flex items-center gap-3">
            <button
              className="md:hidden inline-flex items-center justify-center p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none"
              onClick={() => setDrawerOpen(true)}
              aria-label="Open Menu"
            >
              <Menu className="h-6 w-6" />
            </button>
            <Link to={user ? '/dashboard' : '/'} className="flex items-center gap-2 font-semibold text-lg tracking-tight">
              <Logo size="large" />
            </Link>
          </div>

          {/* Center: Desktop Navigation Links */}
          <nav className="hidden md:flex items-center gap-6 flex-1 justify-center">
            {/* (Removed About Us and Contact Us links per new design) */}
            {/* {latestVersion && (
              <button
                onClick={downloadApp}
                className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200 flex items-center gap-2"
                title={`Download App v${latestVersion.version}`}
              >
                <FontAwesomeIcon icon={faMobileAlt} className="w-4 h-4" />
                <span>Download App</span>
                {latestVersion.version && (
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold">
                    v{latestVersion.version}
                  </span>
                )}
              </button>
            )} */}
          </nav>

          {/* Right: Actions */}
          <div className="flex items-center gap-3">
            {/* Mobile: Notification + Cart */}
            <div className="md:hidden flex items-center gap-3">
              <NotificationBell />
              <CartIcon hideIfEmpty />
            </div>

            {/* Auth */}
            {user ? (
              <div className="hidden md:flex items-center gap-4">
                <NotificationBell />
                <CartIcon />
                <UserProfileDropdown />
              </div>
            ) : (
              <div className="hidden md:flex items-center gap-3">
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-full bg-green-600 text-white hover:bg-green-700 font-medium transition-colors duration-200"
                >
                  Shop Now
                </Link>
                <Link
                  to="/login"
                  className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                >
                  Log in
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      <MobileDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        user={user}
        cartCount={cartCount}
        onLogout={logout}
      />
    </header>
  );
}

export default Header;


